export default __webpack_public_path__ + "static/vision3-6b71706ac15ba17a21a82513e84e3bdd.png";